import React from 'react';

import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';

const ChartCard = ({ title, subtitle, actions, loading, empty, emptyMessage = 'Brak sprzedaży w wybranym okresie', height = 320, children }) => (
    <Paper variant="outlined" sx={ { p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' } }>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={ 1 } mb={ 1 }>
            <Box>
                <Typography variant="h6" sx={ { fontWeight: 600, m: 0 } }>{ title }</Typography>
                { subtitle && <Typography variant="body2" color="text.secondary">{ subtitle }</Typography> }
            </Box>
            { actions }
        </Stack>

        <Box sx={ { height: 4, mb: 1 } }>
            { loading && <LinearProgress/> }
        </Box>

        <Box sx={ { height, position: 'relative' } }>
            {
                empty && !loading
                    ? (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            <Typography variant="body2" color="text.secondary">{ emptyMessage }</Typography>
                        </Stack>
                    )
                    : children
            }
        </Box>
    </Paper>
);

export default ChartCard;
